import { computeFootprintBars, computeDeltaProfile } from "../utils";
const DeltaProfile = {
    name: "DeltaProfile",
    compute: (bars, barIntervalMs = 60000, priceTickSize = 0.01, smaPeriod = 14) => {
        const footprintBars = computeFootprintBars(bars, barIntervalMs, priceTickSize);
        return computeDeltaProfile(footprintBars, smaPeriod);
    },
    render: () => undefined,
};
export default DeltaProfile;
